import { fetcher } from "helpers/fetcher";

import { TDeleteTagReq, TDeleteTagRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteTag = async (payload: TDeleteTagReq) => {
  return await fetcher<TDeleteTagRes, TDeleteTagReq["data"]>(
    ENDPOINT.MANAGEMENT.DELETE_TAG,
    {
      data: payload.data,
      headers: {
        [API_HEADER.BU_ID]: payload.idBu,
        [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.DELETE_TAG.version,
      },
    }
  );
};

export const mutationDeleteTag = async (payload: TDeleteTagReq) => {
  return (await deleteTag(payload)).data.message;
};

mutationDeleteTag._key = (payload: TDeleteTagReq) => [
  ENDPOINT.MANAGEMENT.DELETE_TAG.url,
  payload,
];
